import Footer from "@/components/footer/Footer";
import Navbar from "@/components/navbar/Navbar";
import { AuthContext, type AuthContextProps } from "@/contexts/auth/Auth";
import React, { Suspense, useContext } from "react";



interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
    const { signOut } = useContext(AuthContext) as AuthContextProps;

  return <Suspense>
      <Navbar withNavLinks={false}/>
        {children}
      <Footer/>
    </Suspense>;
};
